import DiceAdjustmentSummary from "./DiceAdjustmentSummary";

export default DiceAdjustmentSummary;
export { DiceAdjustmentSummary };
